// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__q_4m0","bigColWidth":"Table_bigColWidth__221pR","biggerColWidth":"Table_biggerColWidth__2jL6q","row":"Table_row__2cV5N","col":"Table_col__37z3h"};